// Replaces a re-export of pino's own Logger, so consumers that already import this type get their
// log payloads checked against the reserved field names with no change on their side.
export type { Logger } from "./reservedLogFields";
export * from "./logger";
export { enableWorkerLogging, initLoggingTransmission } from "./utils/sendToBackend";
